var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.012 4.57105L11.325 4.57104C9.32309 4.57104 7.7002 6.19394 7.7002 8.19588L7.70019 37.1946C7.70019 39.1965 9.32309 40.8194 11.325 40.8194L33.074 40.8194C35.076 40.8194 36.6989 39.1965 36.6989 37.1946L36.6989 16.8807C36.6989 15.9676 36.3542 15.088 35.7338 14.418L27.6923 5.73314C27.0062 4.99223 26.0422 4.57105 25.0325 4.57105L24.012 4.57105ZM22.1995 8.19588L11.325 8.19588L11.325 37.1946L33.074 37.1946L33.074 19.0704L25.8244 19.0704C23.8224 19.0704 22.1995 17.4475 22.1995 15.4455L22.1995 8.19588ZM31.7452 15.4455L25.8244 15.4455L25.8244 9.0511L31.7452 15.4455ZM16.7623 29.9449C15.7613 29.9449 14.9499 30.7563 14.9499 31.7573C14.9499 32.7583 15.7613 33.5697 16.7623 33.5697L27.6368 33.5697C28.6378 33.5697 29.4492 32.7583 29.4492 31.7573C29.4492 30.7563 28.6378 29.9449 27.6368 29.9449L16.7623 29.9449ZM14.9499 26.3201C14.9499 25.3191 15.7613 24.5076 16.7623 24.5076L27.6368 24.5076C28.6378 24.5076 29.4492 25.3191 29.4492 26.3201C29.4492 27.321 28.6378 28.1325 27.6368 28.1325L16.7623 28.1325C15.7613 28.1325 14.9499 27.321 14.9499 26.3201Z",
    fill: "#85C3F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.47413c94d519463d7e1a7aa300efe7db.svg";
export { ForwardRef as ReactComponent };